import { createAction } from '@reduxjs/toolkit';
import { ICommonLoadActionType, ICommonSaveActionType, ICommonSavePayload } from '../Common.actions';
import { WatchlistStudent } from '../../types/models/WatchlistStudentModel';

export interface IWatchlistActionTypes extends ICommonSaveActionType, ICommonLoadActionType {
  LOAD_BY_COMPANY: string;
  LOAD_BY_STUDENT: string;
  DELETE: string;
  DELETE_SUCCESS: string;
  CONVERT: string;
  CONVERT_SUCCESS: string;
  CONVERT_ERROR: string;
}

export const WATCHLIST: IWatchlistActionTypes = {
  LOAD: 'watchlist/load',
  LOAD_BY_COMPANY: 'watchlist/loadByCompany',
  LOAD_BY_STUDENT: 'watchlist/loadByStudent',
  LOADED: 'watchlist/loadSuccess',
  LOAD_ERROR: 'watchlist/loadError',
  ERROR: 'watchlist/error',
  SAVE: 'watchlist/save',
  SAVED: 'watchlist/saveSuccess',
  SAVE_ERROR: 'watchlist/saveError',
  DELETE: 'watchlist/delete',
  DELETE_SUCCESS: 'watchlist/deleteSuccess',
  CONVERT: 'watchlist/convert',
  CONVERT_SUCCESS: 'watchlist/convertSuccess',
  CONVERT_ERROR: 'watchlist/convertError',
};

// Action Creators
export const watchlistLoadByCompany = createAction<string>(WATCHLIST.LOAD_BY_COMPANY);
export const watchlistLoadByStudent = createAction<string[]>(WATCHLIST.LOAD_BY_STUDENT);
export const watchlistLoadSuccess = createAction<WatchlistStudent[]>(WATCHLIST.LOADED);
export const watchlistLoadError = createAction<string>(WATCHLIST.LOAD_ERROR);

export const watchlistSave = createAction<ICommonSavePayload<any>>(WATCHLIST.SAVE);
export const watchlistSaveSuccess = createAction<WatchlistStudent>(WATCHLIST.SAVED);
export const watchlistSaveError = createAction<string>(WATCHLIST.SAVE_ERROR);

export const watchlistDelete = createAction<string>(WATCHLIST.DELETE);
export const watchlistDeleteSuccess = createAction<string>(WATCHLIST.DELETE_SUCCESS);

export const watchlistConvertToOpportunity = createAction<ICommonSavePayload<any>>(WATCHLIST.CONVERT);
export const watchlistConvertSuccess = createAction<string>(WATCHLIST.CONVERT_SUCCESS);
export const watchlistConvertError = createAction<string>(WATCHLIST.CONVERT_ERROR);